(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const powerSections = new Set();
  let resizeTimer;

  const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const formatHp = (value) => `${Math.round(value)} hp`;
  const formatSigned = (value, suffix) => `${value >= 0 ? '+' : ''}${Math.round(value)}${suffix}`;
  const formatMissing = () => '—';
  const getGraphX = (index, count) => (count <= 1 ? 250 : 20 + (460 / (count - 1)) * index);
  const getData = (element, datasetKey, attributeName) => element.dataset[datasetKey] ?? element.getAttribute(attributeName) ?? '';

  const stageFromDataset = (button, labelKey, hpKey, labelAttribute, hpAttribute, fallbackLabel, isStock = false) => {
    const hp = toNumber(getData(button, hpKey, hpAttribute));

    return {
      label: getData(button, labelKey, labelAttribute) || fallbackLabel,
      hp,
      hasValue: hp > 0,
      isStock,
    };
  };

  const buildStageData = (button) => [
    stageFromDataset(button, 'stockLabel', 'stockHp', 'data-stock-label', 'data-stock-hp', 'Заводска мощност', true),
    stageFromDataset(button, 'stage1Label', 'stage1Hp', 'data-stage-1-label', 'data-stage-1-hp', 'Stage 1'),
    stageFromDataset(button, 'stage1PlusLabel', 'stage1PlusHp', 'data-stage-1-plus-label', 'data-stage-1-plus-hp', 'Stage 1+'),
    stageFromDataset(button, 'stage2Label', 'stage2Hp', 'data-stage-2-label', 'data-stage-2-hp', 'Stage 2'),
    stageFromDataset(button, 'stage2PlusLabel', 'stage2PlusHp', 'data-stage-2-plus-label', 'data-stage-2-plus-hp', 'Stage 2+'),
    stageFromDataset(button, 'stage3Label', 'stage3Hp', 'data-stage-3-label', 'data-stage-3-hp', 'Stage 3'),
    stageFromDataset(button, 'stage4Label', 'stage4Hp', 'data-stage-4-label', 'data-stage-4-hp', 'Stage 4'),
  ];

  const updateSummary = (section, stages) => {
    const stock = stages[0];
    const finalStage = stages[stages.length - 1];
    const stockNode = section.querySelector('[data-pd-power-summary-stock]');
    const finalNode = section.querySelector('[data-pd-power-summary-final]');
    const gainNode = section.querySelector('[data-pd-power-summary-gain]');
    const percentNode = section.querySelector('[data-pd-power-summary-percent]');
    const canCompare = Boolean(stock?.hasValue && finalStage?.hasValue);
    const gain = canCompare ? finalStage.hp - stock.hp : 0;
    const percent = canCompare && stock.hp > 0 ? (gain / stock.hp) * 100 : 0;

    if (stockNode) {
      stockNode.textContent = stock?.hasValue ? formatHp(stock.hp) : formatMissing();
    }

    if (finalNode) {
      finalNode.textContent = finalStage?.hasValue ? formatHp(finalStage.hp) : formatMissing();
    }

    if (gainNode) {
      gainNode.textContent = canCompare ? formatSigned(gain, ' hp') : formatMissing();
    }

    if (percentNode) {
      percentNode.textContent = canCompare ? formatSigned(percent, '%') : formatMissing();
    }
  };

  const updatePowerProfile = (section, button) => {
    const buttons = section.querySelectorAll('[data-pd-power-profile-button]');
    const title = section.querySelector('[data-pd-power-title]');
    const subtitle = section.querySelector('[data-pd-power-subtitle]');
    const note = section.querySelector('[data-pd-power-note]');
    const image = section.querySelector('[data-pd-power-image]');
    const placeholder = section.querySelector('[data-pd-power-placeholder]');
    const rows = section.querySelectorAll('[data-pd-power-row]');
    const line = section.querySelector('[data-pd-power-line]');
    const dots = section.querySelectorAll('[data-pd-power-dot]');
    const maxLabel = section.querySelector('[data-pd-power-max]');
    const cta = section.querySelector('[data-pd-power-cta]');
    const stages = buildStageData(button);
    const graphStages = stages.filter((stage) => stage.hasValue);
    const stockHp = stages[0]?.hasValue ? stages[0].hp : 0;
    const maxHp = Math.max(1, ...graphStages.map((stage) => stage.hp));

    buttons.forEach((item) => {
      const isActive = item === button;
      item.classList.toggle('pd-landing-power-card-active', isActive);
      item.setAttribute('aria-pressed', String(isActive));
    });

    if (title) {
      title.textContent = button.dataset.vehicleName || '';
    }

    if (subtitle) {
      subtitle.textContent = button.dataset.vehicleSubtitle || '';
    }

    if (note) {
      note.textContent = button.dataset.projectNote || '';
    }

    if (image) {
      if (button.dataset.image) {
        image.src = button.dataset.image;
        image.alt = button.dataset.imageAlt || button.dataset.vehicleName || '';
        image.hidden = false;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        image.hidden = true;
      }
    }

    if (placeholder) {
      placeholder.hidden = Boolean(button.dataset.image);
    }

    if (maxLabel) {
      maxLabel.textContent = graphStages.length ? `${Math.round(maxHp)} hp max` : formatMissing();
    }

    if (cta) {
      if (!cta.dataset.defaultHref) {
        cta.dataset.defaultHref = cta.getAttribute('href') || '#';
      }

      cta.textContent = button.dataset.ctaLabel || 'Изпрати запитване за този автомобил';
      cta.href = button.dataset.ctaLink || cta.dataset.defaultHref;
    }

    updateSummary(section, stages);

    rows.forEach((row, index) => {
      const stage = stages[index];

      if (!stage) {
        return;
      }

      const shouldShowRow = stage.isStock || stage.hasValue;
      const gain = stage.hp - stockHp;
      const canCompare = stage.hasValue && stockHp > 0;
      const percent = canCompare ? (gain / stockHp) * 100 : 0;
      const width = stage.hasValue ? Math.max(0, Math.min(100, (stage.hp / maxHp) * 100)) : 0;
      const label = row.querySelector('[data-pd-power-stage-label]');
      const value = row.querySelector('[data-pd-power-stage-value]');
      const gainNode = row.querySelector('[data-pd-power-stage-gain]');
      const percentNode = row.querySelector('[data-pd-power-stage-percent]');
      const fill = row.querySelector('[data-pd-power-bar-fill]');

      row.hidden = !shouldShowRow;
      row.classList.toggle('pd-landing-power-row-strongest', stage.hasValue && stage.hp === maxHp);

      if (label) {
        label.textContent = stage.label;
      }

      if (value) {
        value.textContent = stage.hasValue ? formatHp(stage.hp) : formatMissing();
      }

      if (gainNode) {
        gainNode.textContent = canCompare ? formatSigned(gain, ' hp') : formatMissing();
      }

      if (percentNode) {
        percentNode.textContent = canCompare ? formatSigned(percent, '%') : formatMissing();
      }

      if (fill) {
        fill.style.setProperty('--pd-landing-power-width', `${width}%`);
      }
    });

    const points = graphStages.map((stage, index) => {
      const y = Math.max(30, Math.min(150, 150 - (stage.hp * 120) / maxHp));
      return `${getGraphX(index, graphStages.length)},${y}`;
    });

    if (line) {
      line.setAttribute('points', points.join(' '));
      line.style.display = graphStages.length > 1 ? '' : 'none';
    }

    dots.forEach((dot, index) => {
      const stage = graphStages[index];

      if (!stage) {
        dot.style.display = 'none';
        return;
      }

      const y = Math.max(30, Math.min(150, 150 - (stage.hp * 120) / maxHp));
      dot.style.display = '';
      dot.setAttribute('cx', String(getGraphX(index, graphStages.length)));
      dot.setAttribute('cy', String(y));
      dot.setAttribute('r', stage.hp === maxHp ? '6' : '5');
      dot.classList.toggle('pd-landing-power-dot-strongest', stage.hp === maxHp);
    });
  };

  const refreshPowerSection = (section) => {
    const activeButton = section.querySelector('.pd-landing-power-card-active') || section.querySelector('[data-pd-power-profile-button]');

    if (activeButton) {
      updatePowerProfile(section, activeButton);
    }
  };

  const refreshPowerSections = () => {
    powerSections.forEach(refreshPowerSection);
  };

  const queuePowerResize = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refreshPowerSections, reduceMotion.matches ? 0 : 120);
  };

  const initPowerProfiles = (section) => {
    const buttons = section.querySelectorAll('[data-pd-power-profile-button]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => updatePowerProfile(section, button));
    });

    powerSections.add(section);

    const activeButton = section.querySelector('.pd-landing-power-card-active') || buttons[0];

    if (activeButton) {
      updatePowerProfile(section, activeButton);
    }
  };

  const initReveal = (section) => {
    const items = section.querySelectorAll('[data-pd-reveal]');

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('pd-landing-is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('pd-landing-is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16 }
    );

    items.forEach((item) => observer.observe(item));
  };

  const initSection = (section) => {
    if (!section || section.dataset.pdLandingReady === 'true') {
      return;
    }

    section.dataset.pdLandingReady = 'true';

    initPowerProfiles(section);

    initReveal(section);
  };

  const initAll = (root = document) => {
    if (!root || !root.querySelectorAll) {
      return;
    }

    root.querySelectorAll('[data-pd-landing]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    if (target.matches('[data-pd-landing]')) {
      initSection(target);
      return;
    }

    initAll(target);
  });

  window.addEventListener('resize', queuePowerResize, { passive: true });
})();
